/**
 * Zod schemas for the jobs app.
 */

import { z } from "zod";

export const JobAdSchema = z.object({
  uuid: z.string().uuid(),
  source: z.string(),
  source_url: z.string().nullable(),
  raw_text: z.string(),
  role_title_extracted: z.string(),
  company_name_extracted: z.string(),
  perfect_resume_json: z.record(z.unknown()).nullable(),
  parsed_at: z.string().nullable(),
  comp_band_low_k: z.number().nullable(),
  comp_band_high_k: z.number().nullable(),
  required_skills_extracted: z.array(z.string()),
  // Tracker linkage - populated after async parse completes
  opportunity_uuid: z.string().uuid().nullable().catch(null),
  opportunity_stage: z.string().nullable().catch(null),
  tracker_company_uuid: z.string().uuid().nullable().catch(null),
  created_at: z.string(),
});

export type JobAd = z.infer<typeof JobAdSchema>;

export const JobAdCreateResponseSchema = JobAdSchema.extend({
  task_id: z.string().nullable().optional(),
});
export type JobAdCreateResponse = z.infer<typeof JobAdCreateResponseSchema>;

export const JobAdListResponseSchema = z.object({
  results: z.array(JobAdSchema),
  count: z.number(),
  next: z.string().nullable(),
  previous: z.string().nullable(),
});
